
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRouter} from "vue-router";

    interface State {
        Inspector: string;
        isShowModel: boolean;
    }

    export default defineComponent({
        name: "serviceInfo",
        setup() {
            let state: State = reactive({
                Inspector: '-',
                isShowModel: false,
            })
            // 获取路由器实例
            const router = useRouter()
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo,(data: any) => {
                const {reportDetectOrderVO} = data;
                const {detectManName} = reportDetectOrderVO;
                state.Inspector = detectManName;
            })
            return {
                state,
                router
            }
        },
        methods: {
            showModel() {
                this.state.isShowModel = true
                document.body.style.overflow = "hidden" 
            },
            hiddenModel(){
                this.state.isShowModel = false
                document.body.style.overflow = "" 
            },
            goIntroduce(){
                this.router.push({
                    path:'/idlefishIntroduction'
                })
            },
            toView(){
                this.router.push({
                    path: '/idlefishExplain',
                })
            }
        }
    })
